/* Workoutyes theme.js — sticky header, mobile drawer, cart drawer, newsletter */
(function () {
  'use strict';

  // ---------- Sticky header shadow on scroll ----------
  var header = document.querySelector('[data-site-header]');
  if (header) {
    var setScrolled = function () {
      if (window.scrollY > 8) header.classList.add('is-scrolled');
      else header.classList.remove('is-scrolled');
    };
    setScrolled();
    window.addEventListener('scroll', setScrolled, { passive: true });
  }

  // ---------- Drawer helper ----------
  function openDrawer(drawer) {
    if (!drawer) return;
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
  }
  function closeDrawer(drawer) {
    if (!drawer) return;
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
  }

  // Mobile menu
  document.querySelectorAll('[data-open-menu]').forEach(function (el) {
    el.addEventListener('click', function () {
      openDrawer(document.querySelector('[data-drawer="menu"]'));
    });
  });

  // Cart drawer open
  document.querySelectorAll('[data-open-cart]').forEach(function (el) {
    el.addEventListener('click', function (e) {
      e.preventDefault();
      var d = document.querySelector('[data-drawer="cart"]');
      if (d) {
        openDrawer(d);
        refreshCart();
      }
    });
  });

  // Generic close buttons + overlays
  document.querySelectorAll('[data-drawer]').forEach(function (drawer) {
    drawer.querySelectorAll('[data-close]').forEach(function (btn) {
      btn.addEventListener('click', function () { closeDrawer(drawer); });
    });
    var overlay = drawer.querySelector('.drawer__overlay');
    if (overlay) overlay.addEventListener('click', function () { closeDrawer(drawer); });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      document.querySelectorAll('[data-drawer][aria-hidden="false"]').forEach(closeDrawer);
    }
  });

  // ---------- Cart bubble + drawer ----------
  function updateCartBubbles(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.style.display = count > 0 ? '' : 'none';
    });
  }

  function refreshCart() {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateCartBubbles(cart.item_count);
        renderCartDrawer(cart);
      })
      .catch(function () { /* offline / preview */ });
  }

  function money(cents) {
    var dollars = (cents / 100).toFixed(2);
    return '$' + dollars;
  }

  function renderCartDrawer(cart) {
    var body = document.querySelector('[data-cart-body]');
    var foot = document.querySelector('[data-cart-foot]');
    if (!body || !foot) return;
    if (!cart.items || !cart.items.length) {
      body.innerHTML = '<p class="muted" style="padding:2rem 0;text-align:center;">Your cart is empty.</p>';
      foot.innerHTML = '<a href="/collections/all" class="btn btn--primary btn--block">Browse products</a>';
      return;
    }
    var html = '';
    cart.items.forEach(function (it) {
      html += '<div class="cart-line">' +
              '  <div class="cart-line__media">' + (it.image ? '<img src="' + it.image + '" alt="">' : '') + '</div>' +
              '  <div>' +
              '    <div class="cart-line__title">' + it.product_title + '</div>' +
              (it.variant_title && it.variant_title !== 'Default Title' ? '    <div class="cart-line__variant">' + it.variant_title + '</div>' : '') +
              '    <div class="cart-line__variant">Qty: ' + it.quantity + '</div>' +
              '  </div>' +
              '  <div class="cart-line__price">' + money(it.line_price) + '</div>' +
              '</div>';
    });
    body.innerHTML = html;
    foot.innerHTML =
      '<div style="display:flex;justify-content:space-between;margin-bottom:1rem;font-family:var(--font-display);font-weight:700;">' +
      '<span>Subtotal</span><span>' + money(cart.total_price) + '</span></div>' +
      '<a href="/checkout" class="btn btn--primary btn--block">Checkout</a>' +
      '<a href="/cart" class="btn btn--ghost btn--block" style="margin-top:.5rem;">View cart</a>';
  }

  // Listen for product form add-to-cart
  document.querySelectorAll('form[action="/cart/add"], form[action$="/cart/add"]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var fd = new FormData(form);
      fetch('/cart/add.js', { method: 'POST', body: fd, credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function () {
          refreshCart();
          openDrawer(document.querySelector('[data-drawer="cart"]'));
          showToast('Added to cart');
        })
        .catch(function () { showToast('Could not add'); });
    });
  });

  // Initial cart fetch
  refreshCart();

  // ---------- Toast ----------
  var toastEl;
  function showToast(msg) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'toast';
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = msg;
    toastEl.classList.add('show');
    clearTimeout(showToast._t);
    showToast._t = setTimeout(function () { toastEl.classList.remove('show'); }, 1800);
  }

  // ---------- Newsletter ----------
  document.querySelectorAll('form.newsletter__form').forEach(function (form) {
    form.addEventListener('submit', function () {
      // Let Shopify handle the post — just give visual feedback
      showToast('Thanks for subscribing!');
    });
  });

  // ---------- Quantity inputs in cart page ----------
  document.querySelectorAll('[data-qty]').forEach(function (group) {
    var input = group.querySelector('input');
    var dec = group.querySelector('[data-qty-dec]');
    var inc = group.querySelector('[data-qty-inc]');
    if (!input) return;
    if (dec) dec.addEventListener('click', function () {
      var v = Math.max(1, parseInt(input.value || '1', 10) - 1);
      input.value = v;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
    if (inc) inc.addEventListener('click', function () {
      var v = parseInt(input.value || '1', 10) + 1;
      input.value = v;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });

})();
